import service from "@/store/services/activos-service";
import axios from "axios";

const state = {
  list: {},
  listCode: {},
  activo: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_LIST_CODE: (state, listCode) => {
    state.listCode = listCode;
  },
  SET_RESOURCE: (state, activo) => {
    state.activo = activo;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  listCode({ commit, dispatch }, params) {
    return service.listCode(params).then(({ listCode, meta }) => {
      commit("SET_LIST_CODE", listCode);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((activo) => {
      commit("SET_RESOURCE", activo);
    });
  },

  getDetails({ commit, dispatch }, params) {
    return service.getDetails(params).then((activo) => {
      commit("SET_RESOURCE", activo);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((activo) => {
      commit("SET_RESOURCE", activo);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((activo) => {
      commit("SET_RESOURCE", activo);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },

  async findByQR({ commit }, { qr, empresa }) {
    const url = process.env.VUE_APP_API_BASE_URL;
    const params = new URLSearchParams();
    if (qr) params.append('search', qr);
    params.append('idEmpresa', '172'); // Taller Verticales
    params.append('sortOrder', 'asc');
    params.append('includeRetired', 'false'); // No incluir retirados
    
    const response = await axios.get(`${url}/activos-list?${params.toString()}`);
    return response.data;
  },
};

const getters = {
  list: (state) => state.list,
  listCode: (state) => state.listCode,
  listTotal: (state) => state.meta.pagination.total,
  activo: (state) => state.activo,
  dropdown: (state) => {
    state.list.map((activo) => console.log(activo));
    return state.list.map((activo) => ({
      id: activo.id,
      alias: activo.alias,
    }));
  },
};

const activos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default activos;
